//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_MatchManagerMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_MatchManagerMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_MatchManagerMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    handleRouteBack: function() {
        if (this._bridge.getRouteName() == 'OrgManageMatch') {
            this._bridge.goToScene('OrgManageOrganization', {id: this.target().match.organizationId})
        }
        else {
            this._bridge.back()
        }
    },
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_MatchManagerMediator, BaseMediator);

module.exports = tbs_controller_MatchManagerMediator